<script setup>
import { computed, ref, onMounted } from 'vue';
import ILink from '@components/ILink/ILink.vue';
import IFastBuyModal from '@components/IFastBuyModal/IFastBuyModal.vue';
import EventItemsSkeleton from '@components/EventItemsSkeleton.vue';
import CartItem from './components/CartItem.vue';
import { useCartDataProvider } from '@vueApp/hooks/useCartDataProvider.js';
import useCartStore from '@vueApp/store/modules/cart.js';
import { translator } from '@shop/frontend/web/js/services/TranslatorService';

const cartStore = useCartStore();
const { isGuest } = useCartDataProvider("cart-data-provider");

const orders = computed(() => cartStore.getCart.value);
const loadingCart = ref(true);
const loadingTranslator = ref(true);

onMounted(async () => {
  await translator.getLanguages();
  loadingTranslator.value = false;

  await cartStore.loadCart();
  loadingCart.value = false;
});
</script>

<template>
  <div v-if="!loadingTranslator" class="lk">
    <div class="lk__top">
      <h1 class="lk__title">
        {{ translator.t('main', 'Cart') }}
      </h1>
      <ILink v-if="orders.length" :icon-name="'close-small'" class="button close-btn lk__close-btn"
        data-test-id="clear_cart_btn" @click="cartStore.clearCart">
        <span>
          {{ translator.t('main', 'Clean all') }}
        </span>
      </ILink>
    </div>

    <EventItemsSkeleton v-model="loadingCart">
      <div v-if="orders.length" class="order">
        <CartItem v-for="order in orders" :key="order.id" :order="order" />
      </div>

      <div v-if="!orders.length" class="lk__empty">
        <div class="lk__small-title">
          {{ translator.t('main', 'Cart is empty') }}
        </div>
        <p>
          {{ translator.t('main', 'Your cart is empty. Purchase a match ticket!') }}
        </p>
        <a href="/" class="lk__button btn reset-btn">
          {{ translator.t('main', 'Go to the poster') }}
        </a>
      </div>
    </EventItemsSkeleton>
  </div>

  <IFastBuyModal v-if="isGuest" v-model="cartStore.isShowFastBuyModal.value" />
</template>
